import { uniqBy as _uniqBy, sortBy as _sortBy } from 'lodash';
import store from '..';

const user = {
  namespaced: true,
  state: () => ({ ...window.appState.user, messages: [] }),
  preserveState: false,
  mutations: {
    pointUpdated(state, { data }) {
      state.credit = data.credit;
      state.aff = data.aff;
      state.vip = data.vip;
    },
    receivedMessage(state, { message }) {
      const messages = Array.isArray(message) ? message : [message];
      const mergedMessage = state.messages && Array.isArray(state.messages)
        ? [...state.messages, ...messages]
        : messages;
      const newMessages = _uniqBy(mergedMessage, 'id');
      const sortedMessages = _sortBy(newMessages, 'id');
      state.messages = sortedMessages;
    },
  },
  actions: {
    logout({ state, rootState }) {
      store.replaceState({});
      window.localStorage.removeItem('vuex-multi-tab');
      window.axios.post('/logout').then((response) => {
        window.location.href = '/';
      });
    },
  },
};
export default user;
